import Button from "../UI/Button"
import Modal from "../UI/Modal"

const ThankYouContactUs = (props) => {
    return (
        <Modal>
            <div className="appWrapper flex flex-col h-screen md:h-auto relative justify-center w-full">
                <div className="thanksMsgHolder max-w-full w-full sm:w-[480px] sm:max-w-[480px]  min-h-full sm:min-h-[220px] bg-[#F4F8FD] sm:bg-[#F4F8FD] flex items-center justify-start rounded-none sm:rounded-lg  mx-auto">
                    <div className="px-10 sm:px-10 md:px-10 lg:px-14 py-10 w-full">
                        <div className="flex items-stretch flex-col sm:flex-row">
                            <div className="bar w-[1px] bg-[#7DA1C4] opacity-60 ml-[55px] mr-[46px] hidden"></div>
                            <div className="message w-full">
                                <p className="text-base sm:text-lg leading-6  text-[#333] font-normal tracking-[0.2px]">Thank you for contacting us. Our team will be in touch with you shortly.</p>
                                <Button className="btn mt-10 continueBtn  bg-primaryBlue h-[46px] px-20 py-[10px] font-bold leading-5  text-base justify-center  rounded text-white inline-flex items-center cursor-pointer w-full" onClick={props.onClose}>Continue</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ThankYouContactUs